import React from 'react'
import Navbar from '../navbar/Navbar'

export default ({ children, filterPanel, actionPanel }) => (
  <div>
    <Navbar to="/" />
    <div className="container">
      <div className="section">
        <br />
        {filterPanel}
        {actionPanel}
        <hr />
        {children}
      </div>
    </div>
  </div>
)



// WEBPACK FOOTER //
// ./src/components/templates/portal-list/PortalListLayout.js